

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.04c75ab4.js","_app/immutable/chunks/scheduler.b6a01382.js","_app/immutable/chunks/index.a3f59a79.js","_app/immutable/chunks/singletons.baf01f87.js","_app/immutable/chunks/index.a2248096.js"];
export const stylesheets = [];
export const fonts = [];
